
export default {
    name: 'LeeTagCloud',
    inheritAttrs: false,
    data() {
        return {
            tags: this.tag,
            exp: false,
            setnum: 0,
            px: 0,
            py: 0,
            pw: 0
        }
    },
    mounted() {
        var _this = this
        this.tags.map(function(el, ind) {
            var rnd = Math.floor((Math.random() + 1) * 14 + Math.random() * 2)
            _this.$set(el, 'size', rnd)
            _this.$set(el, 'color', _this.color())
        })
    },
    computed: {
        position() {
            return 'left:'+this.px+'px;top:'+(this.py-50)+'px;transform:translateX(-'+(160-this.pw)*0.5+'px)'
        }
    },
    methods: {
        open(xh) {
            this.px=event.target.offsetLeft
            this.py=event.target.offsetTop
            this.pw=event.target.offsetWidth
            this.exp = true
            var fi = this.tags.filter(function(el, index) {
                return index == xh;
            });
            this.setnum = fi[0].num
        },
        close() {
            this.exp = false
        },
        add(xh) {
            var _this = this
            var fi = this.tags.filter(function(el, index) {
                return index == xh;
            });
            fi.map(function(el) {
                _this.$set(el, 'num', el.num + 1)
            })
            this.setnum = fi[0].num
        },
        remove(xh) {
            this.tags.splice(xh, 1)
        },
        color() {
            var r = Math.floor(Math.random() * 255);
            var g = Math.floor(Math.random() * 255);
            var b = Math.floor(Math.random() * 255);
            var color = 'rgb(' + r + ',' + g + ',' + b + ' )';
            return color
        }
    },
    props: {
        tag: {
            type: Array,
            default () {
                return []
            }
        },
        closeable: {
            type: Boolean,
            default: false
        },
        num: {
            type: Boolean,
            default: false
        }
    }
};
